// extracted by mini-css-extract-plugin
export var root = "CesT";
export var rootDetails = "JyyO";
export var rootDetailsLabel = "_9KNl";
export var rootDetailsName = "+pZB";
export var rootDetailsRole = "UtS4";
export var rootIcon = "X7Jy";
export var rootImage = "LZzY";
export var rootPicture = "-7Zz";